/**
 * How the html body of a template is edited in the template create dialog
 */
export enum TemplateBodyEditorModeEnum {
  /**
   * The tiptap editor. Pasted html is parsed by the editor, which strips unsupported formatting.
   */
  RICH = "rich",

  /**
   * Raw html source with a preview next to it. The html is stored exactly as it is entered.
   */
  HTML = "html"
}
